import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHeroVideo from './DetailPageHeroVideo';

const DetailPageVisionProAppStore = () => {
  return (
    <DetailPage 
      title="Designing the Vision Pro App Store"
      heroSrc={'/images/vision-pro-app-store/header.jpg'}
      content="Apple Vision Pro has a brand-new App Store, where people can discover and download all the incredible apps for visionOS. Being part of the pioneering team that launched the App Store for Vision Pro has been an extraordinary journey. This platform is not just a marketplace; it's a gateway to a new era of spatial computing, where users can explore groundbreaking apps and games designed to harness the unparalleled capabilities of visionOS. From immersive entertainment to innovative productivity tools, the Vision Pro App Store is transforming the way we interact with technology. Contributing to this project has been an honor, and I am eager to witness how it will redefine our digital experiences."
      year="2024"
      duration="2024 – 2025"
      role="Designer"
    >

        <DetailPageHeroVideo
            src="/videos/vision-pro-app-store/Apple-Vision-Pro-app-experiences-visionOS-home.mp4"
            poster="/images/vision-pro-app-store/hero.png"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

    </DetailPage>
  );
};

export default DetailPageVisionProAppStore; 